import { Column } from './column';
export class Distinct {
    col: Column;
    values: any[];
    filter: any[];
    filterBy: string;
    filterValue: any;
    startDate: Date;
    endDate: Date;
    sort: string;
}
